import React from 'react';
import clsx from 'clsx';

interface Props {
	fieldLabel?: string;
	required?: boolean;
	isStandardClass?: boolean;
	additionalClass?: string;
	children?: React.ReactElement;
}

export const Label = (props: Props): React.ReactElement => {
	const { fieldLabel, required, children, additionalClass, isStandardClass } = props;
	return (
		<label className={clsx(isStandardClass && 'form-label col-12', additionalClass)}>
			<>
				{fieldLabel}{' '}
				{
					required && (
						<span className="text-danger">{' '}*</span>
					)
				}
				{children}
			</>
		</label>
	);
};
